import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../../services/http/http.service';

@Component({
  selector: 'app-hackathon',
  templateUrl: './hackathon.component.html',
  styleUrls: ['./hackathon.component.scss']
})
export class HackathonComponent implements OnInit {

  constructor(private httpService: HttpService) { }

  ngOnInit() {
  }
  redirectTo() {
    this.httpService.redirectTo('hackathonquestions');
  }
}
